__webpack_require__.p = "https://givsum-staging.s3.us-west-2.amazonaws.com/packs/";